const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
    <style>
        .filter-scientific-container {
            background-color: #FFFFFF;
            border-radius: 4px;
            border: solid 1px #D9D9D9;
            margin-bottom: 16px;
            padding: 16px;
        }

        h2 {
            color: #000000;
            font-size: 18px;
            font-weight: 600;
            margin: 0;
            line-height: 24px;
        }

        hr {
            border: none;
            height: 1px;
            color: #ECECEC;
            background-color: #ECECEC;
            margin: 16px 0;
        }

        .input-scientific {
            width: -webkit-fill-available;
            margin: 0;
            height: 35px;
            border: 1px solid #ECECEC;
            background-color: #FAFAFA;
            border-radius: 4px;
            font-size: 14px;
            color: #424242;
            padding-left: 42px;
            padding-right: 8px;
            background-repeat: no-repeat;
            background-position: 16px, left;
            background-size: 17px;
            font-weight: 400;
        }

        .input-scientific:focus{
            outline: none;
        }

        .item-scientific-container {
            padding:  8px 0;
        }

        .item-scientific-container label {
            font-size: 16px;
            font-weight: 400;
            color: #424242;
            width: 100%;
            display: block;
            cursor: pointer;
            line-height: 24px;
        }

        .scientific-list-container {
            overflow-y: auto;
            max-height: 300px;
            font-size: 14px;
            margin-top: 10px;
        }

        /* width */
        ::-webkit-scrollbar {
            width: 7px;
            border-radius: 3.5px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
            background: #D8D8D8;
            border-radius: 3.5px;
        }
        
        /* Handle */
        ::-webkit-scrollbar-thumb:hover, ::-webkit-scrollbar-thumb {
            background: #BCBCBC; 
            border-radius: 3.5px;
        }

    </style>
</template>`
styleElement.register("filter-scientific-style");